exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myTeamMembersDialog {\n  padding: 0;\n  border-radius: 5px;\n}\n.myTeamMembersDialog .el-dialog__header {\n  display: none;\n}\n.myTeamMembersDialog .el-dialog__body {\n  padding: 0;\n  height: 650px;\n  max-height: 90vh;\n}\n", ""]);

// exports
